import { currenciesBySite, defaultMeasureUnitIdBySite, measureOptions, site } from '@panel/commons/helpers';
import { createReducer, mergeOnKey } from '../../utils';
import * as Types from './types';

const siteId = site.id;
const { separator } = Object.values(currenciesBySite[siteId])[0];

const defaultCurrency = currenciesBySite[siteId][Object.keys(currenciesBySite[siteId])[0]].code;
const measureSelectOptions = measureOptions.map(m => ({ name: m.symbol, value: m.unit_id }));
const isDualPricePortal = siteId === 'UBPE' || siteId === 'DVPE';
const priceDefault = isDualPricePortal
  ? [
      {
        value: '',
        value_unit: defaultCurrency
      },
      {
        value: '',
        value_unit: currenciesBySite[siteId][Object.keys(currenciesBySite[siteId])[1]].code
      }
    ]
  : [
      {
        value: '',
        value_unit: defaultCurrency
      }
    ];

const initialState = {
  moduleInfo: {},
  formValues: {
    title: '',
    rooms: { feature_id: 'CFT1', value: 0 },
    bedrooms: { feature_id: 'CFT2', value: 0 },
    bathrooms: { feature_id: 'CFT3', value: 0 },
    toilettes: { feature_id: 'CFT4', value: 0 },
    garage: { feature_id: 'CFT7', value: 0 },
    totalArea: { feature_id: 'CFT100', value: '', value_unit: defaultMeasureUnitIdBySite(siteId) },
    coveredArea: { feature_id: 'CFT101', value: '', value_unit: defaultMeasureUnitIdBySite(siteId) },
    price: priceDefault,
    expenses: {
      feature_id: 'CFT6',
      value: '',
      value_unit: defaultCurrency
    },
    iptu: {
      feature_id: 'CFT400',
      value: '',
      value_unit: defaultCurrency
    },
    credit: { feature_id: '1000001', value: false },
    financing: { feature_id: '1000028', value: false },
    ensurance: { feature_id: '2000127', value: false },
    guarantee: { feature_id: '2000174', value: false },
    antiquity: { feature_id: 'CFT5', value: '0' },
    description: '',
    numberOfYears: ''
  },
  unitMeasurement: measureSelectOptions,
  realEstateTypeId: ''
};

function normalize(payload) {
  const {
    title,
    description,
    step,
    module,
    features,
    price_operation_type: pricesByOperation = [],
    unitMeasurement,
    realEstateTypeId
  } = payload;
  const price = [];
  if (pricesByOperation && pricesByOperation[0]) {
    pricesByOperation[0].prices.forEach(p => {
      const priceOption = {
        value: p.amount ? p.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`) : '',
        value_unit: p.currency
      };
      price.push(priceOption);
    });
  }
  return {
    formValues: {
      title,
      description,
      price,
      ...Object.keys(features).reduce((obj, featureKey) => {
        if (features[featureKey] !== null) {
          let ft = features[featureKey];
          if (
            Object.prototype.hasOwnProperty.call(ft, 'feature_id') &&
            ft.feature_id.startsWith('CFT') &&
            ft.value === null
          ) {
            ft = { ...ft, ...initialState.formValues[featureKey] };
          }
          if (features[featureKey].feature_id === 'CFT400') {
            if (features[featureKey].value) {
              ft = { ...ft, value: parseInt(ft.value, 10), value_unit: defaultCurrency };
            }
          }
          if (features[featureKey].feature_id === 'CFT6') {
            if (features[featureKey].value) {
              ft = { ...ft, value: parseInt(ft.value, 10), value_unit: defaultCurrency };
            }
          }
          if (features[featureKey].feature_id === 'CFT5') {
            obj.numberOfYears = parseInt(ft.value, 10) >= 1 ? ft.value : '';
            ft = { ...ft, value: parseInt(ft.value, 10) >= 1 ? '1' : ft.value };
          }
          obj[featureKey] = ft;
        }
        return obj;
      }, {})
    },
    moduleInfo: {
      step,
      module,
      operationType: pricesByOperation[0].operation_type
    },
    unitMeasurement: unitMeasurement.map(m => ({ name: m.symbol, value: m.unit_id })),
    realEstateTypeId
  };
}

const step1Module4Reducer = createReducer(initialState)({
  [Types.GET_FORM_VALUES]: state => ({ ...state, loading: true }),
  [`${Types.GET_FORM_VALUES}_FAILED`]: (state, action) => ({
    ...state,
    ...action.payload,
    loading: false
  }),
  [`${Types.GET_FORM_VALUES}_COMPLETED`]: (state, action) => {
    const { formValues, moduleInfo, unitMeasurement, realEstateTypeId } = normalize(action.payload);

    return {
      ...state,
      loading: false,
      formValues: {
        ...state.formValues,
        ...formValues,
        price: isDualPricePortal
          ? mergeOnKey(state.formValues.price, formValues.price, 'value_unit')
          : formValues.price,
        coveredArea: {
          ...formValues.coveredArea,
          value_unit: unitMeasurement.length > 1 ? formValues.coveredArea.value_unit : unitMeasurement[0].value
        },
        totalArea: {
          ...formValues.totalArea,
          value_unit: unitMeasurement.length > 1 ? formValues.totalArea.value_unit : unitMeasurement[0].value
        }
      },
      moduleInfo,
      unitMeasurement,
      realEstateTypeId
    };
  }
});

export { step1Module4Reducer };
